import { render, staticRenderFns } from "./AddDonation.vue?vue&type=template&id=47a953ec"
import script from "./AddDonation.vue?vue&type=script&lang=js"
export * from "./AddDonation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports